import BaseController from '../../lib/BaseController';
import notifications from '../../services/Notification';
import ajax from '../../services/Ajax';
import messages from '../../services/Messages';
import DateTimeFormatter from '../../lib/DateTimeFormatter';
import co from '../../lib/Co';
import Utils from '../utility/Utils';
import Validator from '../../lib/Validator';
import InspectionGaugesRowController from './InspectionGaugesRowController';
import AppConstants from '../utility/AppConstants';
import $ from 'jquery';

class InspectionAssetImagesController extends BaseController {
  constructor(jobId, jobSowId, testName, assetId, primarySerialNumber, jobNumber) {
    super('inspection-asset-images', {
      inspectionGaugeGUID: [],
      jobId: jobId,
      jobSowId: jobSowId,
      testName: testName,
      assetId: assetId,
      errors: {},
      rows: [],
      assetImages: [],
      rows: [],
      jobNumber: jobNumber,
      primarySerialNumber: primarySerialNumber,
      disableUpload: false,
      signatureImage: {},
      previewUrl: '',
      imgUrl: '',
      images:[],
    });


    this.isLoading = false;
    this._validator = new Validator();
  }


  uploadSignature = (res, file) => {

    const fileType = res.file.name.split('.')[1].toLowerCase() || '';
    if (fileType != 'png' && fileType != 'jpg' && fileType != 'jpeg') {
      notifications.action('error').post({ msg: 'Invalid file type. .' + fileType + ' is an unrecognized file type to upload', title: 'File Error' });
      return false;
    }
    if ((res.file.size / 1048576).toFixed(1) > 25){
      notifications.action('error').post({ msg: 'File size is larger than 25 MB', title: 'File Error' });
      return false;
    }

    this.state.signatureImage = {
      id: this.state.userId,
      fileName: file.fileName,
      fileType: file.fileType,
      imgUrl: file.url,
      MimeType:  res.file.type,
    };
    this.state.hasDiagram = true;
    this.state.imgUrl = file.url;
    this.setPreviewImageLink(URL.createObjectURL(res.file));
    this.commit();
    return true;
  }

  setPreviewImageLink = (url) => {
    this.state.previewUrl = url;
  }

  load() {
    
    //gets list of uploaded images
    const s = this.state;
    co(this, function* () {
      try {
        const results = yield ajax.get('lookup/getInspectionAssetImages', { jobSOWId: s.jobSowId, testName: s.testName,assetId:s.assetId });
        if (results != null && results.length > 0) {
        s.images= results;
          
        }
        this.commit();
      }
      catch (err) {
        notifications.action('error').post({ msg: err.message, title: 'Error loading gauge values' });
      }

    });
  }

  canSave() {
    this._validator.validateAll(this.state);
    this.validateRowValues(this.state);
    var errors = Object.keys(this.state.errors);
    const rows = Utils.filterDeletedRecords(this.state.rows);
    var rowErrors = rows.reduce((acc, curr) => {
      return acc + Object.keys(curr.state.errors).length;
    }, 0);

    if (!errors.length && !rowErrors) {
      this.state.errors = {};
      return true;
    }

    this.commit();
    return false;
  }

  *save() {
   
   return true;
  }

  removeRow(data) {
    var idx = this.state.rows.indexOf(data);
    if (idx === -1) {
      return;
    }

    this.state.rows.splice(idx, 1);
    this.commit();
  }

  SaveCroppedImage = (res, croppedImageLink) => {
    this.state.signatureImage.imgUrl = res;
    this.state.imgUrl = croppedImageLink;
    this.setPreviewImageLink(croppedImageLink);
    //Save the image on Server
    this.SaveImage();
    this.load() ;
    
    this.commit();
    return true;
  }
DiscardImageUpload=()=>{
  this.commit();
  return true;
}
  SaveImage = () => {

    const parameters = {

      inspectionImagesId:Utils.newGuid(),
      assetId:this.state.assetId,
      primarySerialNumber:this.state.primarySerialNumber,
      jobSowId:this.state.jobSowId,
      jobId:this.state.jobId,
      jobNumber:this.state.jobNumber,
      testName: this.state.testName,
      signatureImage: this.state.signatureImage,
    }

    ajax.post('inspection/saveInspectionAssetImage', parameters).then(() => {
      
      notifications.action('success').post({ msg: 'Image saved successfuly', title: 'Image upload' });
      messages.channel('inspection').action('saved').post({ jobId: this.state.jobId });
    }).catch(err => {
      notifications.action('error').post({ msg: err.message, title: 'Error' });
    });
  }

  validateUploadedFile = (type) => {
    const fileType = type.toLowerCase() || '';
    if (fileType != 'png' && fileType != 'jpg' && fileType != 'jpeg') {
      notifications.action('error').post({ msg: 'Invalid file type. .' + fileType + ' is an unrecognized file type to upload', title: 'File Error' });
      return false;
    }
    return true;
  }
}


export default InspectionAssetImagesController;